import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@mui/material/IconButton';

const DialogButtom = ({ onClose, setEditPoint }) => {
    return (
        <>
            <DialogTitle
                style={{
                    alignItems: 'center',
                    color: 'white',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '15px'
                }}
            >
                Origem do ponto: Funcionário
                <IconButton size="small" color="inherit" style={{ position: 'absolute', right: '4%', top: '30%', transform: 'translateY(-50%)' }} onClick={() => onClose(false)}>
                    <CancelIcon style={{ fontSize: 30, color: 'white' }} />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '4px' }}>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'white',
                            color: '#4851de',
                            borderRadius: '20px',
                            flex: 2,
                            height: '50px'
                        }}
                        onClick={() => setEditPoint(true)}
                    >
                        <a style={{ margin: '0 50px' }}>Editar</a>
                    </Button>
                    <Button variant="contained" style={{ backgroundColor: 'white', color: '#4851de', borderRadius: '20px', flex: 2, marginLeft: '5px', height: '50px' }}>
                        Abonar Horas
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
                    <Button variant="contained" style={{ backgroundColor: 'white', color: '#4851de', borderRadius: '20px', flex: 2, marginRight: '1px', height: '50px' }}>
                        Ver Foto
                    </Button>
                    <Button variant="contained" style={{ backgroundColor: 'white', color: '#4851de', borderRadius: '20px', flex: 2, marginLeft: '5px', height: '50px' }}>
                        Ver Local
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
                    <Button variant="contained" style={{ backgroundColor: 'red', color: 'white', borderRadius: '20px', flex: 2, marginRight: '2px', height: '50px' }}>
                        Inativar
                    </Button>
                    <Button variant="contained" style={{ backgroundColor: 'green', color: 'white', borderRadius: '20px', flex: 2, marginLeft: '5px', height: '50px' }}>
                        Aprovar
                    </Button>
                </div>
            </DialogContent>
        </>
    )
}
export default DialogButtom;